import preferences from './preferences';

global.definitions = preferences;
